<template>
  <page-wrapper :title="title">
    <category-list-item
      v-for="item in list"
      :key="item.id"
      v-bind="item"
    ></category-list-item>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import CategoryListItem from "../components/CategoryListItem";

export default {
  components: {
    PageWrapper,
    CategoryListItem
  },
  data() {
    const title = "รายละเอียด Group Category";
    const list = [];

    return {
      title,
      list
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const { categories } = await this.fetchList();
      const list = categories.map(item => ({
        id: item.id,
        name: item.name,
        iconUrl: item.icon_url,
        route: {
          name: "RuejaiClubCategoryDetailPage",
          params: { id: item.id }
        },
        packageCount: item.packages.length
      }));

      this.list = list;
    },
    async fetchList() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.ruejaiClub.groupCategories.categorylist(id);

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}
</style>
